var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchasecard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 70,
    viewBox: "0 0 105 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_92_17982)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_17982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 81.6291,
    height: 46,
    rx: 2.67636,
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 51.8545,
    height: 46,
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7001 53.3586C89.2627 53.9953 90.9376 54.3231 92.629 54.3231V28.9832C90.9376 28.9832 89.2627 29.3109 87.7001 29.9476C86.1374 30.5843 84.7175 31.5176 83.5215 32.6941C82.3255 33.8706 81.3767 35.2673 80.7295 36.8045C80.0822 38.3417 79.749 39.9893 79.749 41.6531C79.749 43.3169 80.0822 44.9645 80.7295 46.5017C81.3767 48.0389 82.3255 49.4356 83.5215 50.6121C84.7175 51.7886 86.1374 52.7219 87.7001 53.3586Z",
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.629 28.9832V13.6758C91.6073 13.6758 90.5955 13.8737 89.6515 14.2584C88.7075 14.643 87.8498 15.2068 87.1273 15.9175C86.4048 16.6282 85.8317 17.4719 85.4407 18.4005C85.0497 19.3291 84.8485 20.3244 84.8485 21.3295C84.8485 22.3346 85.0497 23.3298 85.4407 24.2584C85.8317 25.187 86.4048 26.0307 87.1273 26.7414C87.8498 27.4521 88.7075 28.0159 89.6515 28.4005C90.5955 28.7852 91.6073 28.9832 92.629 28.9832Z",
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0874 37.8887C35.0874 45.5797 42.5765 51.8145 51.8147 51.8145C61.0529 51.8145 68.542 45.5797 68.542 37.8887V11H35.0874V37.8887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_92_17982)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_92_17982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7057 35.6197V32.8327C43.7058 32.4697 43.6343 32.1103 43.4955 31.7749C43.3566 31.4395 43.153 31.1348 42.8964 30.8781C42.6397 30.6214 42.335 30.4177 41.9997 30.2788C41.6643 30.1399 41.3049 30.0684 40.9419 30.0684V34.7361C40.9419 35.4692 41.2331 36.1722 41.7514 36.6906C42.2697 37.209 42.9726 37.5003 43.7057 37.5005V35.6197Z",
    fill: "url(#paint0_linear_92_17982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5043 34.9571H43.3102C42.7374 34.8773 42.2029 34.6234 41.7793 34.2296C41.3556 33.8358 41.0633 33.3214 40.9419 32.7559V34.9571C40.9419 35.6901 41.2331 36.3932 41.7514 36.9116C42.2697 37.43 42.9726 37.7213 43.7057 37.7214H47.2703C47.2704 37.3583 47.1989 36.9986 47.0599 36.6631C46.9209 36.3276 46.7171 36.0227 46.4603 35.766C46.2034 35.5093 45.8984 35.3057 45.5628 35.1669C45.2272 35.0281 44.8675 34.9568 44.5043 34.9571Z",
    fill: "url(#paint1_linear_92_17982)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.6646 32.9908V30.9062H48.3725V32.4458H49.3204V32.9908H47.6646Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4421 32.9908L51.36 30.9062H52.0559L52.9738 32.9908H52.2419L51.564 31.2398H51.8399L51.162 32.9908H50.4421ZM50.988 32.6275L51.168 32.1212H52.1339L52.3139 32.6275H50.988Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5735 30.9062H56.2814V32.9908H55.5735V30.9062ZM54.9196 32.9908H54.2117V30.9062H54.9196V32.9908ZM55.6215 32.2225H54.8716V31.6448H55.6215V32.2225Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2783 33.0384C58.1144 33.0384 57.9664 33.0126 57.8344 32.961C57.7024 32.9074 57.5924 32.83 57.5044 32.7287L57.8854 32.282C57.9414 32.3495 57.9964 32.4012 58.0504 32.4369C58.1044 32.4706 58.1604 32.4875 58.2183 32.4875C58.3703 32.4875 58.4463 32.4012 58.4463 32.2284V31.4363H57.7324V30.9062H59.1452V32.1867C59.1452 32.4726 59.0712 32.686 58.9233 32.827C58.7753 32.9679 58.5603 33.0384 58.2783 33.0384Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3228 32.9908L61.2407 30.9062H61.9366L62.8545 32.9908H62.1226L61.4447 31.2398H61.7207L61.0427 32.9908H60.3228ZM60.8688 32.6275L61.0487 32.1212H62.0146L62.1946 32.6275H60.8688Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3595 36.2667L50.3205 35.4955L51.1124 34.6289H51.8833L50.9954 35.5997L50.6025 35.9987L50.3595 36.2667ZM49.7266 36.7134V34.6289H50.4225V36.7134H49.7266ZM51.1064 36.7134L50.4885 35.9034L50.9474 35.421L51.9253 36.7134H51.1064Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8117 36.7134L53.7296 34.6289H54.4255L55.3434 36.7134H54.6115L53.9336 34.9624H54.2095L53.5316 36.7134H52.8117ZM53.3576 36.3501L53.5376 35.8439H54.5035L54.6835 36.3501H53.3576Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5813 36.7134V34.6289H57.1632L58.0031 35.9898H57.6971L58.513 34.6289H59.095L59.101 36.7134H58.456L58.45 35.5937H58.552L57.9941 36.5258H57.6821L57.1002 35.5937H57.2262V36.7134H56.5813Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.573 36.7611C61.251 36.7611 61.0001 36.6747 60.8201 36.502C60.6401 36.3293 60.5501 36.0871 60.5501 35.7754V34.6289H61.258V35.7545C61.258 35.9134 61.287 36.0265 61.345 36.094C61.403 36.1595 61.481 36.1923 61.579 36.1923C61.679 36.1923 61.757 36.1595 61.813 36.094C61.871 36.0265 61.9 35.9134 61.9 35.7545V34.6289H62.5959V35.7754C62.5959 36.0871 62.5059 36.3293 62.3259 36.502C62.1459 36.6747 61.895 36.7611 61.573 36.7611Z",
    fill: "#4254EA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_92_17982",
    x: 0.00628966,
    y: 0.00628966,
    width: 104.774,
    height: 69.1447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.578616,
    dy: 0.578616
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.78616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.329412 0 0 0 0 0.917647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_17982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_17982",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_92_17982",
    x1: 44.3185,
    y1: 30.0838,
    x2: 41.9225,
    y2: 34.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6DFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#90D4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "#76CEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_92_17982",
    x1: 45.8766,
    y1: 34.2715,
    x2: 42.0009,
    y2: 36.3883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666667,
    stopColor: "#5BC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#5DC9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#60CAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#65CBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6BCCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#72CEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#7BD1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533333,
    stopColor: "#83D3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8BD5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#93D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733333,
    stopColor: "#99D8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9EDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#A1DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933333,
    stopColor: "#A3DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4DBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_17982"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 81.6291,
    height: 46,
    rx: 2.67636,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_92_17982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4182,
    height: 8.02909,
    fill: "white",
    transform: "translate(40.1055 29.9023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_92_17982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.02545,
    height: 8.02909,
    fill: "white",
    transform: "translate(40.6074 29.9023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasecard);
export default __webpack_public_path__ + "static/media/purchasecard.208e55f300f03edfc8416a4b9c11bbc2.svg";
export { ForwardRef as ReactComponent };